import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './components/Landing';
import LoginScreen from './components/Auth/LoginScreen';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import ChangePassword from './components/Auth/ChangePassword';
import Signup from './components/Auth/Signup';
import VerifyEmail from './components/Auth/VerifyEmail';
import Subscribe from './components/Auth/Subscribe';
import Account from './components/Auth/Account';
import SubscribeSuccess from './components/Auth/SubscribeSuccess';
import WebinarRegister from './components/Webinar/Register';
import AdminScreen from './components/Auth/AdminScreen';
import ClientSelector from './components/Dashboard/ClientSelector';
import Dashboard from './components/Dashboard/Dashboard';
import Canvas from './components/Canvas/Canvas';
import ReadOnlyMapView from './components/ReadOnlyMapView';
import ShareView from './components/ShareView';
import NotFound from './components/NotFound';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/subscribe/success" element={<SubscribeSuccess />} />
        <Route path="/webinar" element={<WebinarRegister />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><AdminScreen /></ProtectedRoute>} />
        <Route path="/clients" element={<ProtectedRoute><ClientSelector /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/map/:id" element={<ProtectedRoute><Canvas /></ProtectedRoute>} />
        <Route path="/map/:id/view" element={<ProtectedRoute><ReadOnlyMapView /></ProtectedRoute>} />
        <Route path="/share/:token" element={<ShareView />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
